import { render, staticRenderFns } from "./tabPage.vue?vue&type=template&id=7c0eec91&"
import script from "./tabPage.vue?vue&type=script&lang=js&"
export * from "./tabPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports